import { Box } from '@material-ui/core';

import { KeyboardShortcut } from '@/components/shared/components/KeyboardShortcut';
import { MainNav } from '@/components/shared/components/MainNav';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const SuperSearchBarTrigger = () => {
  const {
    state: { platform },
  } = useConfigContext();

  const {
    actions: { setShowSuperSearchBar },
  } = usePageContext();

  const handleClick = () => {
    setShowSuperSearchBar(true);
  };

  return (
    <Box onClick={handleClick} pb={2}>
      <MainNav
        textId={'SEARCH_BAR'}
        icon={'search'}
        linkTo={undefined}
        endAdornement={
          platform ? (
            <KeyboardShortcut command={platform === 'mac' ? 'Cmd+K' : 'Ctrl+Shift+K'} iconName="keyboard_command_key" />
          ) : undefined
        }
      />
    </Box>
  );
};
